import { withPrefix } from "gatsby";
import { useGatsbyLocation } from "./useGatsbyLocation";

const stripPathPrefix = (path: string) => {
  const prefix = withPrefix("");
  return path.replace(prefix, "/");
};

export const usePathname = () => {
  const { pathname } = useGatsbyLocation();
  return stripPathPrefix(pathname);
};
